<template>
    <transition>
        <div
            v-if="isVisible"
            ref="main"
            class="main"
            @pointerdown="onBackdropPress"
            @click="onCloseClick($event)"
        >
            <div ref="card" :class="['card card-container', isVisible ? 'popup-shown' : 'popup-hidden', resize ? 'has-custom-width' : '']">
                <slot></slot>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'PopupView',
    props: {
      isVisible: {
          type: Boolean,
          default: false,
      },
      resize:{
          type: Boolean
      }
    },
    emits: ['close'],
    data() {
        return {
            isClosing: false,
            layerOpenAtPress: false,
        };
    },
    watch: {
        isVisible(newValue) {
            if (newValue) {
                this.isClosing = false;
            }
        }
    },
    methods: {
        close() {
            if (this.isClosing) return;

            const card = this.$refs.card;
            if (!card) {
                this.$emit('close');
                return;
            }

            this.isClosing = true;
            const handleAnimationEnd = () => {
                this.isClosing = false;
                this.$emit('close');
            };

            card.addEventListener('animationend', handleAnimationEnd, { once: true });

            if (card.classList.contains('popup-shown')) {
                card.classList.remove('popup-shown');
                card.classList.add('popup-hidden');
            } else {
                this.isClosing = false;
                this.$emit('close');
            }
        },
        onKeydown(event) {
            if (event.key !== 'Escape' || !this.isVisible || this.isClosing) return;
            const openPopups = document.querySelectorAll('.card-container.popup-shown');
            if (openPopups[openPopups.length - 1] !== this.$refs.card) return;
            if (this.hasOpenLayer()) return;

            event.stopPropagation();
            this.close();
        },
        hasOpenLayer() {
            return !!document.querySelector('.quick-menu-overlay, body > .menu, .ts-panel, .p-datepicker:not(.p-datepicker-inline), .p-dropdown-panel, .p-multiselect-panel');
        },
        onBackdropPress(event) {
            this.layerOpenAtPress = event.target === this.$refs.main && this.hasOpenLayer();
        },
        onCloseClick(event) {
            if (event.target !== this.$refs.main) return;
            if (this.layerOpenAtPress) {
                this.layerOpenAtPress = false;
                return;
            }
            this.close();
        }
    },
    mounted() {
        window.addEventListener('keydown', this.onKeydown);
    },
    beforeUnmount() {
        window.removeEventListener('keydown', this.onKeydown);
    }
}
</script>

<style lang="scss" scoped>
.has-custom-width{
  width: 600px !important;
}
.main {
    z-index: 9999;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(8, 10, 15, 0.65);
    backdrop-filter: blur(6px);
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: right;

}

.card {
    max-height: 100vh;
    overflow-y: auto;
    min-width: 385px;
    max-width: 600px;
    border-top-left-radius: $radius-default;
    border-bottom-left-radius: $radius-default;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    animation-duration: .3s;
    animation-fill-mode: forwards ;

    &.popup-shown {
        animation-name: slideInRight;
    }

    &.popup-hidden {
        animation-name: slideOutRight;
    }
}

.v-enter-active,
.v-leave-active {
    transition: all .2s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}

@keyframes slideInRight {
    0% {
        opacity: 0;
        transform: translateX(100%);
    }

    100% {
        opacity: 1;
        transform: translateX(0%);
    }
}

@keyframes slideOutRight {
    0% {
        opacity: 1;
        transform: translateX(0%);
    }

    100% {
        opacity: 0;
        transform: translateX(100%);
    }
}

@keyframes SlideInDown {
    0% {
        opacity: 0;
        transform: translateY(100%);
    }

    100% {
        opacity: 1;
        transform: translateY(0%);
    }
}

@keyframes SlideOutDown {
    0% {
        opacity: 1;
        transform: translateY(0%);
    }

    100% {
        opacity: 0;
        transform: translateY(100%);
    }
}


@media (max-width: $screen-md) {
  .has-custom-width{
    width: 100% !important;
  }
    .card {
        width: 100%;
        min-width: 0;
        height: 95%;
        position: absolute;
        bottom: 0;
        padding: 10px !important;
        overflow-y: scroll;
        border-radius: $radius-default $radius-default 0 0;
        transition: all 1s ease-in-out;

        &.popup-shown {
            animation-name: SlideInDown;
        }

        &.popup-hidden {
            animation-name: SlideOutDown;
        }
    }
}
</style>
